<template>
  <div class="table-container">
    <div class="header">
      <el-button type="primary" @click="handleAdd" icon="el-icon-plus">新增合作伙伴</el-button>
    </div>

    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>

      <el-table-column prop="partnerName" label="合作伙伴"></el-table-column>
      <el-table-column
          label="图片"
          align="center">
        <template slot-scope="scope">
          <el-image
              style="width: 100px; height: 60px"
              :src="$store.state.baseApi + scope.row.partnerLogo"
              fit="contain"
              :preview-src-list="[$store.state.baseApi + scope.row.partnerLogo]">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            修改
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="currentPage"
          :page-sizes="[8,16,24,32]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="合作伙伴" prop="partnerName">
          <el-input v-model="form.partnerName" placeholder="请输入合作伙伴名称"></el-input>
        </el-form-item>
        <el-form-item label="合作伙伴图片" prop="partnerLogo">
          <el-upload
              class="avatar-uploader"
              action="http://www.weste-sound.com/api/file/uploadLogoPic"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
<!--          <el-upload
              class="avatar-uploader"
              action="http://192.168.1.3:8091/file/uploadLogoPic"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">-->
            <img v-if="form.partnerLogo" :src="$store.state.baseApi+form.partnerLogo" class="avatar">
            <i v-else>
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 8,
      total: 0,
      imageUrl: '',
      dialogVisible: false,
      dialogTitle: '新增合作伙伴',
      form: {
        id: '',
        partnerName: '',
        partnerLogo: ''
      },
      rules: {
        partnerName: [
          {required: true, message: '请输入合作伙伴名称', trigger: 'blur'}
        ],
      },
      editIndex: -1
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$api.getPartner({
        page: this.currentPage,
        nums: this.pageSize,
      }).then(res => {
        if (res.code == 200) {
          const mockData = res.data.list;
          this.tableData = mockData.map((item, index) => ({
            ...item,
            index: index + 1
          }));
          this.total = res.data.total;
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增合作伙伴';
      this.form = {
        id: '',
        partnerName: '',
        partnerLogo: '',
      };
      this.imageUrl = '';
      this.dialogVisible = true;
      this.editIndex = -1;
    },
    handleEdit(index, row) {
      this.dialogTitle = '修改合作伙伴';
      this.form = {
        id: row.id,
        partnerName: row.partnerName,
        partnerLogo: row.partnerLogo
      };
      this.dialogVisible = true;
      this.editIndex = index;
    },
    handleDelete(index, row) {
      this.$confirm('确定要删除这条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.deletePartner({id: row.id}).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.fetchData();
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.editIndex === -1) {
            // 新增
            this.$api.addPartner({
              partnerName: this.form.partnerName,
              partnerLogo: this.form.partnerLogo,
            }).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.fetchData();
              }
            });
          } else {
            // 修改
            this.$api.updatePartner({
              id: this.form.id,
              partnerName: this.form.partnerName,
              partnerLogo: this.form.partnerLogo,
            }).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.fetchData();
              }
            });
          }
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      //只能上传图片
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式！');
      }
      return isLt5M && isJPG;
    },
    handleAvatarSuccess(res, file) {
      /*【这个对图片进行压缩处理，临时的缩略显示】*/
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        this.form.partnerLogo = res.data;
        this.$message({
          showClose: true,
          message: '恭喜你，上传成功✔',
          type: 'success'
        });
      }
    },
  }
}
</script>

<style scoped>
.table-container {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.header {
  margin-bottom: 20px;
}

.block {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 10px;
  width: 100%;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  max-width: 400px;
  height: 178px;
  display: block;
}

</style>